import styled from "styled-components";
import { COLORS, FONT_SIZE, FONT_WEIGHT } from "../../../constants/Styles";

export const CheckboxTextStyles = styled.div`
  color: ${COLORS.secondaryLight};
  font-size: ${FONT_SIZE.size14};
  font-weight: ${FONT_WEIGHT.weight400};
`;
